import styled from 'styled-components';

import { PlusSIcon } from 'assets/icons';
import { Button } from 'components/uikit/Button/Button';

export const AddDriverButton = styled(Button).attrs({ Icon: PlusSIcon, theme: 3 })`
  max-width: 137px;
  align-self: ${({ position }) => {
    switch (position) {
      case 'left':
        return 'flex-start';

      case 'right':
        return 'flex-end';

      default:
        return position;
    }
  }};
`;
